/**
 * @generated SignedSource<<ac7f59f6bfbbf09a8049fefcb50e16f9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PrivateNoteSidePanelDeleteMutation$variables = {
  privateNoteId: string;
};
export type PrivateNoteSidePanelDeleteMutation$data = {
  readonly deletePrivateNote: {
    readonly stream: {
      readonly privateNotes: ReadonlyArray<{
        readonly id: string;
      }>;
    };
  } | null;
};
export type PrivateNoteSidePanelDeleteMutation = {
  response: PrivateNoteSidePanelDeleteMutation$data;
  variables: PrivateNoteSidePanelDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "privateNoteId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "privateNoteId",
    "variableName": "privateNoteId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "PrivateNote",
  "kind": "LinkedField",
  "name": "privateNotes",
  "plural": true,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PrivateNoteSidePanelDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeletePrivateNote",
        "kind": "LinkedField",
        "name": "deletePrivateNote",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "stream",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PrivateNoteSidePanelDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeletePrivateNote",
        "kind": "LinkedField",
        "name": "deletePrivateNote",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "stream",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c0b34a7a524b76ae13e60460adafe020",
    "id": null,
    "metadata": {},
    "name": "PrivateNoteSidePanelDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation PrivateNoteSidePanelDeleteMutation(\n  $privateNoteId: ID!\n) {\n  deletePrivateNote(privateNoteId: $privateNoteId) {\n    stream {\n      privateNotes {\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9286d09433c69dfff3e70aa365c7b585";

export default node;
